//import { AlertDialogComponent } from "./../../../../components/alert-dialog/alert-dialog.component";
import { ICompany } from "./../../../../interfaces/company";
import { MatCheckboxChange, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ICourseType } from "src/app/interfaces/course-type";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CourseTypeService } from "./../../../../services/http/business/course-type/course-type.service";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { IYearList } from "src/app/interfaces/calendar-yearList";
import { ITermInfo } from "src/app/interfaces/term-info";
import * as moment from "jalali-moment";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-term-info-entry",
  templateUrl: "./term-info-entry.component.html",
  styleUrls: ["./term-info-entry.component.css"]
})
export class TermInfoEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  valError: boolean;
  yearList: IYearList;
  errors = new Array();
  companyList: ICompany;
  companySelected: string;
  courseTypeList: ICourseType[];
  parrentTermList: IParentTerm[];

  constructor(
    private fb: FormBuilder,
    // private dialog: MatDialog,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private comapnyService: CompanyService,
    private termInfoService: TermInfoService,
    private calendatService: CalendarService,
    private courseTypeService: CourseTypeService,
    private parrentTermService: ParrentTermService,
    private dialogRef: MatDialogRef<TermInfoEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: ITermInfo
  ) { }

  ngOnInit() {
    this.getYear();
    this.createForm();
    this.checkOwner();

    this.getParrentTermList();
    this.companySelected = this.isOwner ? null : this.cidService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getComapnyList();
        if (this.data)
          this.getCourseType();
      }
      else {
        this.getCourseType();
        this.form.controls[""].patchValue(this.cidService.getCID())
      }
    });
  }

  getComapnyList() {
    this.comapnyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: any) {
    this.cidService.setCID(e);
    this.getParrentTermList();
    this.getCourseType();
  }

  createForm() {
    this.form = this.fb.group({
      company: [null],
      ParentTermId: [
        this.data && this.data.ParentTermId ? this.data.ParentTermId : null,
        Validators.compose([Validators.required])
      ],
      TermNumber: [
        this.data && this.data.TermNumber ? this.data.TermNumber : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(32767)
        ])
      ],
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([Validators.required, Validators.maxLength(50)])
      ],
      ExchangePauseStartDate: [
        this.data && this.data.ExchangePauseStartDate
          ? this.data.ExchangePauseStartDate
          : null,
        Validators.compose([Validators.required])
      ],
      ExchangePauseEndDate: [
        this.data && this.data.ExchangePauseEndDate
          ? this.data.ExchangePauseEndDate
          : null,
        Validators.compose([Validators.required])
      ],
      PreRegStartDate: [
        this.data && this.data.PreRegStartDate,
        Validators.compose([Validators.required])
      ],
      PreRegEndDate: [
        this.data && this.data.PreRegEndDate ? this.data.PreRegEndDate : null,
        Validators.compose([Validators.required])
      ],
      RegStartDate: [
        this.data && this.data.RegStartDate ? this.data.RegStartDate : null,
        Validators.compose([Validators.required])
      ],
      RegEndDate: [
        this.data && this.data.RegEndDate ? this.data.RegEndDate : null,
        Validators.compose([Validators.required])
      ],
      StartDate: [
        this.data && this.data.StartDate ? this.data.StartDate : null,
        Validators.compose([Validators.required])
      ],
      EndDate: [
        this.data && this.data.EndDate ? this.data.EndDate : null,
        Validators.compose([Validators.required])
      ],
      // FinalDate: [null],
      SMSFinal: [(this.data && this.data.SMSFinal) ? this.data.SMSFinal : null],
      CourseTypeId: [
        this.data && this.data.CourseTypeId ? this.data.CourseTypeId : null,
        Validators.compose([Validators.required])
      ],
      Id: [this.data && this.data.Id ? this.data.Id : 0],
      StatusForEdit: [true]
    });
  }

  getParrentTermList() {
    this.parrentTermService.list(0, 0).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  genTitle(event: MatCheckboxChange, title) {
    if (event.checked) {
      if (this.form.controls['Title'].value)
        this.form.controls['Title'].patchValue(this.form.controls['Title'].value + title + ' ');
      else
        this.form.controls['Title'].patchValue(title + ' ');
    }
    else
      this.form.controls['Title'].patchValue(this.form.controls['Title'].value.replace(title + ' ', ''));
  }

  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  getYear() {
    this.calendatService.yearList().subscribe(res => {
      this.yearList = res;
    });
  }

  submit(data: ITermInfo) {
    this.errors = new Array();
    data.ExchangePauseStartDate = moment
      .from(data.ExchangePauseStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.ExchangePauseEndDate = moment
      .from(data.ExchangePauseEndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.PreRegStartDate = moment
      .from(data.PreRegStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.PreRegEndDate = moment
      .from(data.PreRegEndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.RegStartDate = moment
      .from(data.RegStartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.RegEndDate = moment
      .from(data.RegEndDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);

    // if (data.FinalDate) {
    //   data.FinalDate = moment
    //     .from(data.FinalDate, "en")
    //     .utc(true)
    //     .format(environment.dateFormat);
    // }
    // if (data.ExchangePauseEndDate < data.ExchangePauseStartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11607")
    //   });
    // }
    // if (data.PreRegEndDate < data.PreRegStartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11608")
    //   });
    // }
    // if (data.RegEndDate < data.RegStartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11609")
    //   });
    // }
    // if (data.EndDate < data.StartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11610")
    //   });
    // }
    // if (data.PreRegEndDate > data.StartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11611")
    //   });
    // }
    // if (data.PreRegEndDate > data.StartDate) {
    //   this.dialog.open(AlertDialogComponent, {
    //     data: this.translate.get("serviceErrors.11612")
    //   });
    //  } else {
    if (this.data && this.data.Id) {
      this.termInfoService.edit(data).subscribe(
        () => {
          //this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    } else {
      this.termInfoService.add(data).subscribe(
        () => {
          // this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
    // }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
